export const filters = () => ({
        price: [Infinity, 0],
        stops: [],
        duration: [Infinity, 0],
        airline: [],
        airport: [],
        isSameAirport: false,
        transferAirport: [],
        baggage: [],
        class: [],
        brandedFareName: [],
        refundable: [],
        startTime: [0, 1439],
        endTime: [0, 1439],
        flightNumber: null,
        supplierName: [],
    }),
    searchRequest = () => ({
        convertToCurrency: null,
        routes: [],
        adults: 1,
        childrenAges: [],
        partialResponse: true,
    }),
    searchScheduleResponse = (routesCount = 1) => ({
        routes: [...new Array(routesCount)].map(() => searchResponse()),
    }),
    searchResponse = () => ({
        filters: filters(),
        offers: [],
    })
